var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "5 5 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_591_162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_591_162",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_591_162",
    transform: "scale(0.009)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_591_162",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAgKADAAQAAAABAAAAgAAAAABIjgR3AAAD0UlEQVR4Ae2dgVHbQBBFJSaFhEoid5CkB9dhqMM9JOkgRyWkkigS3DGLLGM7Pp289x8zmTvJmtPu+882RgQ1DV8QgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABPwT23/78Hv/5qTh/pW3+JX2sGIPvYrVh+/PzxkfleauUFGASfiIqKYGcAEfCl5VASoAT4UtKICPAmeHLSSAhwIXhS0lQvQD/Gb6MBFULcGX4EhJUK0Cm8KuXoEoBToQfYqpdSjeOIY5dHKdDlT8nuJt26X37VPgf/cQvPhaOMOji2kce9rm7KgGuCT/FpyZBNQLkCF9RgioEyBm+mgTuBVgifCUJXAuwZPgqErgVoET4ChK4FGD//flhCKdLAU3GRT6vn/x08FrTpJTb33QpwPbH/cOANszgXST8dJ4PJAixpnSom9GlACPdmTAWDT8lutZ50/lzj24FGEGYMIqEn+Cvdd50/pzjp5yLrbFWDKP4qdc6b+5GXb8C5IahuB4CKKZuekYAA0NxigCKqZueEcDAUJwigGLqpmcEMDAUpwigmLrpGQEMDMUpAiimbnpGAANDcYoAiqmbnhHAwFCcIoBi6qZnBDAwFKcIoJi66RkBDAzFKQIopm56RgADQ3GKAIqpm54RwMBQnCKAYuqmZwQwMBSnCKCYuukZAQwMxSkCKKZuekYAA0NxigCKqZueEcDAUJwW/d/B+6/P3RTy9td9mO5T2l6bSTEBXhpt27kbNFX552rPlniGycBqU+qJwVvA2UnVeSAC1Jnr2V0Vews4u6ICB9by1z1yoOIVIAdFx2sggOPwcpSOADkoOl4DARyHl6N0BMhB0fEaCOA4vBylI0AOio7XQADH4eUoHQFyUHS8xuoCzF0Nc8zzotJvofdiAhy9utW2u4uo1XTwXdPNtXOU1dzBV+4rfS0gDPV2k5q7lzuA/G1CycYnNRTdjJfGd01/wGKsI5QspqwAbf/U9G130GA/vAq0zW64D9DBQ3I7RkYFv4r/MsaJmz0VbP0GT9X2j6VvPVPse4A33H3/+DZn8o5A6fDHkxcXYHyfH67Ht81g+7vutTdC0/ebNRAUfwuwTb5889e3X4Z9nd0vNA/DE+FpjWd+YryqAKmIcbyFz8S2nqXnKp94lubI+hCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhDQJPAPIOzzC346NmwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/UploadFile.6e11260b8c14cd2a9c281181c6c485c0.svg";
export { ForwardRef as ReactComponent };